// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-grid[data-v-71664a65]{grid-gap:max(1em,min(calc(.5em + 3.5vmin),3em));display:grid;grid-template-columns:repeat(auto-fit,minmax(min(45%,370px),1fr));grid-template-columns:repeat(auto-fit,minmax(min(45%,var(--max-width,370px)),1fr))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
